import { PreviewComponent } from '@/services/utils/basePreview'
import { metadataLabelValues } from '@/shared/helpers/metadataLabelValues'
import { INotificationTrigger } from '@/modules/notification-center/event-trigger/types/triggerTypes'
import TriggerCustomPreview from '@/modules/notification-center/event-trigger/components/TriggerCustomPreview.vue'

/**
 * dynamic component generator method
 * @param trigger is INotificationTrigger interface type which
 * @return An Array of IPreviewComponent trigger type
 */
export function triggerPreviewComponents(
  trigger: INotificationTrigger
): PreviewComponent<INotificationTrigger>[] {
  return [
    PreviewComponent.custom<INotificationTrigger>(
      'variables',
      TriggerCustomPreview,
      { trigger: trigger }
    ),

    ...metadataLabelValues(trigger)
  ]
}
